import Upsertable from '@/models/Upsertable'
import { useEconomicStore } from '@/stores/economicStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Economic extends Upsertable {
  static store() {
    return useEconomicStore()
  }

  store() {
    return Economic.store()
  }

  static all() {
    return Economic.store().getAll
  }

  static find(uuid) {
    const obj = Economic.store().find(uuid)
    let economic = new Economic()
    return Object.assign(economic, obj)
  }
}

useModelName(Economic, "Economic")
ModelRegistry.register(Economic, "Economic")